module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sparkline",
    style: ({
      'height': _vm.height
    }),
    attrs: {
      "id": _vm.id
    }
  }, [_c('svg', {
    staticStyle: {
      "margin-top": "8"
    },
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": _vm.gradientId,
      "x1": "0",
      "x2": "0",
      "y1": "1",
      "y2": "0"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "10%",
      "stop-color": "#c6e48b"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "33%",
      "stop-color": "#7bc96f"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "66%",
      "stop-color": "#239a3b"
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": "90%",
      "stop-color": "#196127"
    }
  })], 1), _vm._v(" "), _c('mask', {
    attrs: {
      "id": _vm.sparklineId,
      "x": "0",
      "y": "0",
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('polyline', {
    attrs: {
      "transform": 'translate(0, ' + _vm.height + ') scale(1,-1)',
      "points": _vm.points,
      "fill": "transparent",
      "stroke": "#8cc665",
      "stroke-width": "2"
    }
  })])], 1), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "translate(0, 1.0)"
    }
  }, [_c('rect', {
    staticStyle: {
      "stroke": "none"
    },
    style: ({
      fill: _vm.fill,
      mask: _vm.mask
    }),
    attrs: {
      "x": "0",
      "y": "-2",
      "width": _vm.width,
      "height": _vm.height
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a73e6bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dashboard/components/Sparkline.vue
// module id = 207
// module chunks = 5